import { Button as ButtonLib } from "@ui-lib/index"

export default function Button(args: { label: string; onClick: () => void; disabled?: boolean }) {
	return (
		<ButtonLib
			className={`my-2 px-4`}
			onClick={args.onClick}
			disabled={args.disabled}
		>
			<ButtonLib.Label>{args.label}</ButtonLib.Label>
		</ButtonLib>
	)
}
